<template>
  <div class="chunk">
    <emd-input-text v-if="
      inputObject.type === 'string'
      && !inputObject.hasOwnProperty('enum')"
      :name="name"
      :title="inputObject.title"
      :required="required"
      :maxLength="inputObject.maxLength"
      :minLength="inputObject.minLength"
      :attrs="inputObject.attrs"
      :conditionalEvents="eventsStatus"
      :conditionalActions="actionsStatus"
      :onInput="validateInput"
      :value="localModel"
      v-model="localModel"
    />

    <emd-input-number v-if="inputObject.type === 'number' || inputObject.type === 'integer'"
      :name="name"
      :title="inputObject.title"
      :required="required"
      :step="inputObject.multipleOf"
      :max="inputObject.maximum"
      :min="inputObject.minimum"
      :attrs="inputObject.attrs"
      :onInput="validateInput"
      :value="localModel"
      :type="inputObject.type"
      v-model="localModel"
    />

    <emd-input-boolean v-if="inputObject.type === 'boolean'"
      :name="name"
      :title="inputObject.title"
      :required="required"
      :value="localModel || inputObject.default"
      :onInput="validateInput"
      v-model="localModel"
    />

    <emd-multiple-select
      v-if="inputObject.type === 'array'
      && inputObject.items
      && inputObject.items.hasOwnProperty('enum')"
      :name="name"
      :title="inputObject.title"
      :value="localModel || inputObject.default"
      :items="inputObject.items"
    />

    <emd-select v-if="inputObject.type === 'string' && inputObject.hasOwnProperty('enum')"
      :name="name"
      :title="inputObject.title"
      :required="required"
      :value="localModel || inputObject.default"
      :enumList="inputObject.enum"
      :onInput="validateInput"
      v-model="localModel"
    />

    <emd-input-array v-if="
      inputObject.type === 'array'
      && !inputObject.items.enum"
      :name="name"
      :title="inputObject.title"
      :required="required"
      :value="localModel"
      :items="inputObject.items"
      :minItems="inputObject.minItems"
      :maxItems="inputObject.maxItems"
      :onInput="validateInput"
      v-model="localModel"
    />
  </div>
</template>
<script>
import EmdInputText from './EmdInputText.vue'
import EmdInputNumber from './EmdInputNumber.vue'
import EmdInputBoolean from './EmdInputBoolean.vue'
import EmdSelect from './EmdSelect.vue'
import EmdInputArray from './EmdInputArray.vue'
import EmdMultipleSelect from './EmdMultipleSelect.vue'

export default {
  name: 'FormBuilderInputRender',
  props: {
    inputObject: {
      required: true,
      type: Object
    },
    model: {
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    }
  },
  components: {
    EmdInputText,
    EmdInputNumber,
    EmdInputBoolean,
    EmdSelect,
    EmdInputArray,
    EmdMultipleSelect
  },
  data () {
    return {
      localModel: this.model
    }
  },
  methods: {
    validateInput (e) {
      e.preventDefault()
      const element = e.target
      const valid = e.target.validity.valid
      const helper = element.nextSibling
      if (valid) {
        element.classList.remove('_state_error')
        helper.classList.remove('_state_error')
        helper.innerHTML = ''
        return true
      } else {
        element.classList.add('_state_error')
        helper.classList.add('_state_error')
        helper.innerHTML = element.validationMessage
        return false
      }
    }
  },
  watch: {
    localModel (newValue) {
      this.$emit('input', { name: this.name, data: newValue })
    }
  },
  computed: {
    eventsStatus () {
      return this.$store.getters.getEventsStatus()
    },
    actionsStatus () {
      return this.$store.getters.getActionsStatus()
    }
  }
}
</script>
